import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const TableSkeleton = () => {
    return (
        <div className={`flex border-bottom-1 align-center w-100 p-3`}>
            <div className="table-avatar-skeleton">
                <Skeleton height={72} style={{ lineHeight: 2, overflow: "hidden" }} />
            </div>
            <div className="flex justify-start w-25 p-2 px-4">
                <div className="flex-column w-100">
                    <div className="w-80">
                        <Skeleton />
                    </div>
                    <div className="w-70">
                        <Skeleton />
                    </div>
                </div>
            </div>
            <div className="flex justify-start w-20 p-2 px-4">
                <div className="flex-column w-100">
                    <Skeleton />
                    <Skeleton />
                </div>
            </div>
            <div className="flex justify-start w-25 p-2 px-4">
                <div className="flex-column w-100">
                    <div className="w-80">
                        <Skeleton />
                    </div>
                    <div className="w-70">
                        <Skeleton />
                    </div>
                </div>
            </div>
            <div className="flex justify-start w-20 p-2 px-4">
                <div className="flex-column w-100">
                    <div className="w-80">
                        <Skeleton />
                    </div>
                    <div className="w-70">
                        <Skeleton />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TableSkeleton;
